import BidButton from '../../elements/BidButton/BidButton'
import { useContext, useState } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import { delay } from '@components/BiddingButtons/functions'
import TagManager from 'react-gtm-module'
import TiktokPixel from 'tiktok-pixel'
import pushKlaviyoBidEvent from '@utilities/functions/pushKlaviyoBidEvent'

const Bid = ({
  item,
  loadingBid,
  expired,
  handleBan,
  setLoadingBid,
  toggleModal,
  setModalAction,
  setModalData,
  updateItem,
  location,
}: any) => {
  const {
    instance,
    userData: { profile },
  } = useContext<any>(AuthContext)
  const [error, setError] = useState<string>('')
  const [bidMessage, setBidMessage] = useState<string | null>('')
  const { id, auctionId, highBidder, nextBid, quantity } = item
  const isHighBidder = highBidder === profile.id

  const getBidButtonLabel = () => {
    if (error) return error
    if (isHighBidder) return `Next Bid: $${nextBid.toFixed(2)}`
    if (bidMessage) return bidMessage
    if (loadingBid) return 'Bidding...'
    return `Bid $${nextBid ? nextBid.toFixed(2) : 'FIGURE OUT MNR NO NEXT BID'}`
  }

  const handleBid = async (e: any) => {
    try {
      e.stopPropagation()
      const auctionDetails = await instance.get(
        `/auction/auctionDetails/${auctionId}`
      )
      const modalData = {
        bid: nextBid,
        qty: quantity,
        location: auctionDetails.data.location.nickName,
        type: 'Bid',
      }
      toggleModal(true, 'Bid')
      setModalAction(() => placeBid)
      setModalData(modalData)
    } catch (e: any) {
      console.error('Bid Error: ', JSON.stringify(e))
    }
  }

  const placeBid = async () => {
    setLoadingBid(true)
    try {
      const bidResults = await instance.post(`/bid/bidAuctionItems`, {
        auctionId,
        itemId: id,
        currentBid: nextBid,
      })
      if (
        bidResults.data.msg &&
        bidResults.data.msg.includes('Your account is currently suspended')
      ) {
        handleBan('Bid')
      } else if (
        bidResults.data.msg &&
        bidResults.data.msg.includes('This account is currently suspended')
      ) {
        handleBan('Bid', true)
      } else if (bidResults.data.success !== false) {
        pushKlaviyoBidEvent({ profile, item, location })
        setBidMessage(bidResults.data.msg)

        updateItem(bidResults.data.item)
        TagManager.dataLayer({
          dataLayer: {
            event: 'handle-bidding',
            'data-bidding-next-bid': item.nextBid,
            'data-bidding-current-bid': item.currentBid,
          },
        })
        TiktokPixel.init('CO5BJN3C77U6IP9P2760', { email: profile.email }).then(
          () =>
            TiktokPixel.track('Bid', {
              content_id: id,
              content_type: 'product',
              value: nextBid,
              currency: 'USD',
              email: profile.email,
            })
        )

        await delay(3000)
        setBidMessage('')
      }
    } catch (e) {
      setError('Sorry, something went wrong')
      await delay(3000)
      setError('')
    }

    setLoadingBid(false)
  }

  return (
    <div
      className={`transition duration-300 ease-in-out ${
        loadingBid ? ' opacity-25' : 'opacity-100'
      }`}
    >
      <BidButton
        label={getBidButtonLabel()}
        theme="blue-light"
        callBack={handleBid}
        width="full"
        size={'lg'}
        disabled={isHighBidder || expired}
        success={isHighBidder}
        data-auction-number={item.auctionNumber}
        data-bid={nextBid}
        data-item-id={item.id}
        data-lot-code={item.lotCode}
        data-bidder-id={profile.id}
        data-current-bid={item.currentBid}
        track
      />
    </div>
  )
}

export default Bid
